import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-housing',
  templateUrl: './booking-housing.component.html',
  styleUrls: ['./booking-housing.component.css']
})
export class BookingHousingComponent implements OnInit {

  addHousingMode: boolean = false;
  joinHousingMode: boolean = false;
  housingType: string = "";
  roomNber: string = "";
  roomcode: string = "";

  constructor() { }

  ngOnInit() {
  }
  clean() {
    this.addHousingMode = false;
    this.joinHousingMode = false;
  }
  moveToAddHousingMode() {
    this.clean();
    this.addHousingMode = true;
  }

  moveToJoinHousingMode() {
    this.clean();
    this.joinHousingMode = true;
  }

}
